<template>
  <div class="loading-wrapper"></div>
</template>

<script setup></script>

<style lang="scss" scoped>
.loading-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 3px;
    z-index: 9;
    background-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.15) 0%,
      rgba(0, 0, 0, 0.05) 100%
    );
    animation: gradientAnim 1.5s linear infinite;
  }
}

@keyframes gradientAnim {
  0% {
    left: 0;
    width: 0;
  }
  35% {
    left: 0;
    width: 50%;
  }
  65% {
    left: 50%;
    width: 50%;
  }
  100% {
    left: 100%;
    width: 0;
  }
}
</style>
